import { action } from "mobx";
import { initialState } from "./state";

// Array setters
const createArraySetter = (store, key) =>
  action(function(items) {
    if (Array.isArray(items)) {
      this[key] = [...items];
    } else if (items === null || items === undefined) {
      this[key] = [];
    } else {
      console.warn(`${key} received invalid data:`, items);
      if (!Array.isArray(this[key])) {
        this[key] = [];
      }
    }
  });

// Simple setters
const createSimpleSetter = (store, key) =>
  action(function(value) {
    this[key] = value;
  });

export const createMutations = store => ({
  // Simple setters
  setIsLoading: createSimpleSetter(store, "isLoading"),
  setSearchText: createSimpleSetter(store, "searchText"),
  setFilterModel: action(function(model) {
    this.filterModel = model;
    this.applyFilters();
  }),
  setHasError: createSimpleSetter(store, "hasError"),
  setErrorMessage: createSimpleSetter(store, "errorMessage"),
  setLandingPageResponseData: createSimpleSetter(store, "landingPageResponseData"),
  setIsResponseModalOpen: createSimpleSetter(store, "isResponseModalOpen"),

  // Array setters
  setLandingPageCompletionMetrics: createArraySetter(store, "landingPageCompletionMetrics"),
  setFilteredLandingPageCompletionMetrics: createArraySetter(store, "filteredLandingPageCompletionMetrics"),

  // Reset state
  setDefaultState: action(() => {
    Object.keys(initialState).forEach(key => {
      store[key] = initialState[key];
    });
  }),

  // Modal actions
  openResponseModal: action(function(data) {
    this.landingPageResponseData = data;
    this.isResponseModalOpen = true;
  }),

  closeResponseModal: action(function() {
    this.isResponseModalOpen = false;
    this.landingPageResponseData = null;
  })
});